import React, { useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css";

declare global {
  interface Window {
    opera?: any;
  }
}

function Bilheteria(props: any) {
  const [deviceType, setDeviceType] = useState("");

  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      window.open("https://play.google.com/store/apps/details?id=air.com.ticket360.Ticket360&hl=pt_BR&pli=1");
    } else if (/iPad|iPhone|iPod/.test(userAgent)) {
      window.open("https://apps.apple.com/br/app/ticket360/id924966976");
    } else {
      document.location = "https://www.ticket360.com.br/";
    }
  }, []);

  return <></>;
}

export default Bilheteria;
